import "../CSS/styles.css";
import c1 from '../../assets/c1.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";

const Clients = () => {
          useEffect(() => {
            AOS.init({
              duration: 1000,
              once: false,
            });
          }, []); 
  return (
    <div className="container-fluid px-0 mt-lg-5 vbg py-5 inter" data-aos="fade-up">
      <div className="row py-lg-5">
        <h1 className="mb-0 bc fw-bold text-center">What Our Clients Say</h1>
        <p className="gc mb-0 text-center mt-2">Hear what our clients have to say about working with TAMBRO.</p>
        <div className="container px-lg-5 mt-lg-0 mt-5">
          <div className="row px-lg-5">
            <div className="p-lg-5">
              <div className="p-lg-5">
                <div id="carouselExampleIndicators" className="carousel slide">
                  <div className="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="0"
                      className="active"
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="2"
                      aria-label="Slide 3"
                    ></button>
                  </div>
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="container px-lg-5">
                        <div className="row pe-lg-5 wcc align-items-center">
                          <div className="col-lg-4 col-12 p-lg-5">
                            <img src={c1} className="ps-lg-5 p-lg-0 p-4 d-block w-100" alt="..." />
                          </div>
                          <div className="col-lg-8 col-12 pe-lg-5 pb-lg-0 pb-5">
                            <p className="mb-0 fs-5">" The custom fabrication work Tambro did for our infrastructure project was impeccable. Their precision and quality control measures are truly industry-leading.</p>
                            <p className="blc mb-0 fw-bold mt-5">Hassan Malik</p>
                            <p className="lbc mb-0">Project Manager, Urban Development Corp</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="container px-lg-5">
                        <div className="row pe-lg-5 nbg wcc align-items-center">
                          <div className="col-lg-4 col-12 p-lg-5">
                            <img src={c1} className="ps-lg-5 p-lg-0 p-4 d-block w-100" alt="..." />
                          </div>
                          <div className="col-lg-8 col-12 pe-lg-5 pb-lg-0 pb-5">
                            <p className="mb-0 fs-5">" The custom fabrication work Tambro did for our infrastructure project was impeccable. Their precision and quality control measures are truly industry-leading.</p>
                            <p className="blc mb-0 fw-bold mt-5">Hassan Malik</p>
                            <p className="lbc mb-0">Project Manager, Urban Development Corp</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="container px-lg-5">
                        <div className="row pe-lg-5 nbg wcc align-items-center">
                          <div className="col-lg-4 col-12 p-lg-5">
                            <img src={c1} className="ps-lg-5 p-lg-0 p-4 d-block w-100" alt="..." />
                          </div>
                          <div className="col-lg-8 col-12 pe-lg-5 pb-lg-0 pb-5">
                            <p className="mb-0 fs-5">" The custom fabrication work Tambro did for our infrastructure project was impeccable. Their precision and quality control measures are truly industry-leading.</p>
                            <p className="blc mb-0 fw-bold mt-5">Hassan Malik</p>
                            <p className="lbc mb-0">Project Manager, Urban Development Corp</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="prev"
                  >
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="next"
                  >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Clients